import { LoadingButton } from "@mui/lab";
import { Box, Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { FC, useState } from "react";
import { P } from "theme/typography";
import { CollectUserView, FirmWithLenses, NamedFirm } from "generated/graphql";
import PCheckbox from "components/PCheckbox";
import { updateCollectUserFirms } from "redux/slices/client";

interface Props {
  open: boolean;
  onClose: () => void;
  user: CollectUserView;
  firms: FirmWithLenses[];
}

const CollectUserFirmPicker: FC<Props> = ({ open, onClose, user, firms }) => {
  const [loading, setLoading] = useState(false);
  const snackpatch = useAppDispatchWithSnackbar();
  const [firmsToSave, setFirmsToSave] = useState<NamedFirm[]>(user.firms);

  const handleSave = () => {
    setLoading(true);
    snackpatch(
      updateCollectUserFirms({
        collectUserId: user.id,
        firms: firmsToSave,
      }),
      {
        successMessage: "Firm permissions updated",
        errorMessage: "Unable to update firm permissions",
      }
    )
      .then(onClose)
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <P variant="h5">Firm Access</P>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "400px",
            mt: 2,
          }}>
          <P
            sx={{
              mb: 1,
            }}>
            Select firms to grant to this user
          </P>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "300px",
              overflow: "auto",
            }}>
            {firms.map((firm) => (
              <Box key={firm.id}>
                <PCheckbox
                  checked={firmsToSave.find((f) => f.id === firm.id) !== undefined}
                  label={firm.name}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFirmsToSave((prev) => [
                        ...prev,
                        { id: firm.id, name: firm.name, externalId: firm.externalId },
                      ]);
                    } else {
                      setFirmsToSave((prev) => prev.filter((f) => f.id !== firm.id));
                    }
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton loading={loading} onClick={handleSave} variant="contained">
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CollectUserFirmPicker;
